import { graphql } from "gql.tada";

const WizardStepMut = graphql(`
  mutation processWizardStep($input: ProcessWizardStepInput!) {
    processWizardStep(input: $input) {
      constraints {
        minValue
        maxValue
        scope
        reference
        warningMessage
      }
      languageCode
      nodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        active
      }
      projectNodeId
      projectId
      currentStep
      totalSteps
      availableSteps
      subType
      topology
      fieldKeyGroup
      currentQuestionnaire {
        title
        description
        info
        position
        id
        questions {
          title
          identifier
          position
          description
          info
          iconName
          fieldGroups {
            title
            key
          }
          constraints {
            scope
            reference
            minValue
            maxValue
            warningMessage
          }
          fields {
            title
            fieldGroupId
            fieldKey
            fieldValue
            fieldType
            fieldInputType
            fieldDefaultValue
            fieldMin
            fieldMax
            values
            enabled
            onAction {
              fieldValueChange {
                newValue
                states {
                  fieldKey
                  fieldValue
                  fieldMax
                  fieldMin
                  fieldInputType
                  fieldKeyGroup
                  enabled
                }
              }
            }
            iconName
          }
        }
      }
      questionnaires {
        title
        description
        info
        position
        id
        questions {
          title
          identifier
          position
          description
          info
          iconName
          fieldGroups {
            title
            key
          }
          constraints {
            scope
            reference
            minValue
            maxValue
            warningMessage
          }
          fields {
            title
            fieldGroupId
            fieldKey
            fieldValue
            fieldType
            fieldInputType
            fieldDefaultValue
            fieldMin
            fieldMax
            values
            enabled
            onAction {
              fieldValueChange {
                newValue
                states {
                  fieldKey
                  fieldValue
                  fieldMax
                  fieldMin
                  fieldInputType
                  fieldKeyGroup
                  enabled
                }
              }
            }
            iconName
          }
        }
      }
    }
  }
`);

const createWizardStepQuestionnaire = graphql(`
  mutation addWizardStepQuestionnaire($input: AddQuestionnaireInput!) {
    addWizardStepQuestionnaire(input: $input) {
      title
      description
      info
      position
      id
      questions {
        title
        identifier
        position
        description
        info
        iconName
        fieldGroups {
          title
          key
        }
        constraints {
          scope
          reference
          minValue
          maxValue
          warningMessage
        }
        fields {
          title
          fieldGroupId
          fieldKey
          fieldValue
          fieldType
          fieldInputType
          fieldDefaultValue
          fieldMin
          fieldMax
          values
          enabled
          onAction {
            fieldValueChange {
              newValue
              states {
                fieldKey
                fieldValue
                fieldMax
                fieldMin
                fieldInputType
                fieldKeyGroup
                enabled
              }
            }
          }
          iconName
        }
      }
      __typename
    }
  }
`);

const updateWizardStepQuestionnaireMut = graphql(`
  mutation modifyWizardStepQuestionnaire($input: ModifyQuestionnaireInput!) {
    modifyWizardStepQuestionnaire(input: $input) {
      id
      title
    }
  }
`);

const deleteWizardStepQuestionnaireMut = graphql(`
  mutation removeWizardStepQuestionnaire($input: RemoveQuestionnaireInput!) {
    removeWizardStepQuestionnaire(input: $input) {
      id
      position
    }
  }
`);

const duplicateWizardStepQuestionnaireMut = graphql(`
  mutation cloneWizardStepQuestionnaires($input: CloneQuestionnairesInput!) {
    cloneWizardStepQuestionnaires(input: $input) {
      identifier
      title
      id
      position
    }
  }
`);

const AddWizardMutation = graphql(`
  mutation addWizard($input: AddWizardInput!) {
    addWizard(input: $input) {
      constraints {
        minValue
        maxValue
        scope
        reference
        warningMessage
      }
      languageCode
      nodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        active
      }
      projectNodeId
      projectId
      currentStep
      totalSteps
      availableSteps
      subType
      topology
      fieldKeyGroup
      currentQuestionnaire {
        title
        description
        info
        position
        id
        questions {
          title
          identifier
          position
          description
          info
          iconName
          fieldGroups {
            title
            key
          }
          constraints {
            scope
            reference
            minValue
            maxValue
            warningMessage
          }
          fields {
            title
            fieldGroupId
            fieldKey
            fieldValue
            fieldType
            fieldInputType
            fieldDefaultValue
            fieldMin
            fieldMax
            values
            enabled
            onAction {
              fieldValueChange {
                newValue
                states {
                  fieldKey
                  fieldValue
                  fieldMax
                  fieldMin
                  fieldInputType
                  fieldKeyGroup
                  enabled
                }
              }
            }
            iconName
          }
        }
      }
      questionnaires {
        title
        description
        info
        position
        id
      }
    }
  }
`);

const WizardDeleteMut = graphql(`
  mutation removeWizard($input: RemoveWizardInput!) {
    removeWizard(input: $input) {
      status
      message
    }
  }
`);

const ToggleCommissioningCostNodeMut = graphql(`
  mutation toggleCommissioningCostNode(
    $input: ToggleCommissioningCostNodeInput!
  ) {
    toggleCommissioningCostNode(input: $input) {
      status
      message
    }
  }
`);

export {
  AddWizardMutation,
  WizardStepMut,
  createWizardStepQuestionnaire,
  updateWizardStepQuestionnaireMut,
  deleteWizardStepQuestionnaireMut,
  duplicateWizardStepQuestionnaireMut,
  WizardDeleteMut,
  ToggleCommissioningCostNodeMut,
};
